import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@glu/theming';
import TimePicker from './TimePicker';
import { types } from './Recurrence.reducer';

const styles = {

};

const MinutesHours = ({
  classes, canSetTime, onChange, atTime, minTime, maxTime, hideMinutes
}) => (
  <div data-qa="daily" className={`${classes.daily} `}>
    {canSetTime && (
      <TimePicker
        htmlId="daily-timePicker"
        onChange={(time) => onChange({
          type: types.AT_TIME,
          response: time.value
        })}
        minTime={minTime}
        maxTime={maxTime}
        value={atTime}
        hideMinutes={hideMinutes}
      />
    )}
  </div>
);

MinutesHours.propTypes = {
  /** Classes provided by the theme */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /** Allows for setting a time of day */
  canSetTime: PropTypes.bool,

  /** Hides minute controls, only displaying hours to control * */
  hideMinutes: PropTypes.bool,

  /** String containing at time value */
  atTime: PropTypes.string,

  /** Minimum time value of input */
  minTime: PropTypes.string,

  /** Maximum time value of input */
  maxTime: PropTypes.string,

  /** Callback to set recurrence value */
  onChange: PropTypes.func.isRequired
};

MinutesHours.defaultProps = {
  canSetTime: true,
  atTime: undefined,
  minTime: undefined,
  maxTime: undefined,
  hideMinutes: false
};

export const BareMinutesHours = MinutesHours;
export default withTheme(withStyles(styles)(MinutesHours));
